export const mgs = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 20,
  inputPaddingInline: 14,

  inputHeight: 38,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 14,
  inputFontFamily: '"Arial", sans-serif',
  inputColor: "#676666",
  inputBackgroundColor: "#ffffff",
  inputFontWeight: 400,

  inputBorderColor: "#DADBDE",
  inputBorderWidth: 1,
  inputBorderRadius: 6,

  inputHoverColor: "#676666",
  inputHoverBorderColor: "#DADBDE",
  inputHoverBackgroundColor: "#ffffff",

  // **********************************
  //  Select field
  selectTopSpacing: 20,
  selectPaddingInline: 14,

  selectHeight: 38,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 14,
  selectFontFamily: '"Arial", sans-serif',
  selectColor: "#676666",
  selectBackgroundColor: "#F0F0F0",
  selectFontWeight: 400,

  selectBorderColor: "#ffffff",
  selectBorderWidth: 1,
  selectBorderRadius: 6,

  selectHoverColor: "#676666",
  selectHoverBorderColor: "#DADBDE",
  selectHoverBackgroundColor: "#F0F0F0",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 20,
  textAreaPaddingInline: 14,

  textAreaHeight: 152,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 14,
  textAreaFontFamily: '"Arial", sans-serif',
  textAreaColor: "#676666",
  textAreaBackgroundColor: "#ffffff",
  textAreaFontWeight: 400,

  textAreaBorderColor: "#DADBDE",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 6,

  textAreaHoverColor: "#676666",
  textAreaHoverBorderColor: "#DADBDE",
  textAreaHoverBackgroundColor: "#ffffff",

  // **********************************
  //  placeholder
  placeholderColor: "#676666",
  placeholderFontFamily: '"Arial", sans-serif',
  placeholderFontSize: 14,
  placeholderFontWeight: 400,
  placeholderHoverColor: "#676666",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 6,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 14,
  fieldLabelColor: "#676666",
  fieldLabelFontWeight: 700,
  fieldLabelColorAsterisk: "#676666",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Arial", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#676666",
  descriptionFontSize: 14,
  descriptionFontWeight: 400,
  descriptionFontFamily: '"Arial", sans-serif',
  descriptionTopSpacing: 10,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 14,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 6,
  checkboxUncheckedBorderColor: "#DADBDE",
  checkboxUncheckedBackgroundColor: "#ffffff",
  checkboxCheckedBackgroundColor: "#F58232",
  checkboxCheckedBorderColor: "#DADBDE",
  checkboxCheckedColor: "#ffffff",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Arial", sans-serif',
  checkboxLabelFontSize: 14,
  checkboxLabelFontWeight: 400,
  checkboxLabelColor: "#676666",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 14,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#DADBDE",
  radioUncheckedBackgroundColor: "#ffffff",
  radioCheckedBackgroundColor: "#F58232",
  radioCheckedBorderColor: "#DADBDE",

  radioAlignment: "none",

  radioLabelFontFamily: '"Arial", sans-serif',
  radioLabelFontSize: 14,
  radioLabelFontWeight: 400,
  radioLabelColor: "#676666",

  // **********************************
  // submit button

  submitMarginTop: 30,
  submitFontSize: 14,
  submitFontFamily: "'Arial', sans-serif",
  submitWidth: 118,
  submitWidthUnits: "px",
  submitHeight: 52,
  submitBorderRadius: 0,
  submitBorderWidth: 1,
  submitBackground: "#F58232",
  submitColor: "#ffffff",
  submitBorderColor: "#F58232",
  submitBackgroundHover: "#F58232",
  submitBorderColorHover: "#F58232",
  submitColorHover: "#ffffff",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 700,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "left",
};

  